// Mock data for Template 2 editable system
export const mockRootProps = {
  topContactInfo: {
    hours: "Mon - Fri 8:00 - 18:00 / Sunday 8:00 - 14:00",
    phone: "1-800-458-56987", 
    address: "47 Bakery Street, London, UK",
    socialMedia: {
      facebook: "#",
      twitter: "#", 
      instagram: "#",
      linkedin: "#"
    }
  },
  businessInfo: {
    name: "Visibeen Automotive",
    logo: "/images/template2-logo.png",
    heroTitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    heroSubtitle: "Professional automotive services you can trust",
    ctaText: "let's talk",
    heroImages: [
      "/images/automotive-hero.jpg"
    ]
  },
  navigation: {
    menuItems: ["Home", "Services", "About Us", "Blog", "Contacts"]
  },
  aboutUs: {
    title: "who we are",
    heading: "Lorem ipsum dolor sit amet,",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    features: [
      "Lorem ipsum dolor sit",
      "Lorem ipsum dolor sit", 
      "Lorem ipsum dolor sit"
    ],
    ctaText: "Info About Us",
    image: "/images/automotive-hero.jpg"
  },
  services: [
    {
      id: 1,
      title: "Lorem ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
      image: "/images/automotive-service-1.jpg",
      hasArrow: true
    },
    {
      id: 2, 
      title: "Lorem ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
      image: "/images/automotive-service-2.jpg",
      hasArrow: true
    },
    {
      id: 3,
      title: "Lorem ipsum", 
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
      image: "/images/automotive-service-3.jpg",
      hasArrow: true
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Leslie Alexander",
      role: "MANAGER",
      review: "A logistic service provide company plays a pivotal role in the global supply chain logistic service provider company a logistic services provider",
      image: "/images/testimonial-1.jpg",
      rating: 5
    },
    {
      id: 2,
      name: "Leslie Alexander", 
      role: "MANAGER",
      review: "A logistic service provide company plays a pivotal role in the global supply chain logistic service provider company a logistic services provider",
      image: "/images/testimonial-2.jpg",
      rating: 5
    },
    {
      id: 3,
      name: "Leslie Alexander",
      role: "MANAGER", 
      review: "A logistic service provide company plays a pivotal role in the global supply chain logistic service provider company a logistic services provider",
      image: "/images/testimonial-3.jpg",
      rating: 5
    }
  ],
  technologies: [
    {
      id: 1,
      title: "Lorem",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      image: "/images/technology-1.jpg",
      date: "April 21, 2020",
      comments: 0
    },
    {
      id: 2,
      title: "Lorem",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing", 
      image: "/images/technology-2.jpg",
      date: "April 21, 2020",
      comments: 0
    },
    {
      id: 3,
      title: "Lorem",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing",
      image: "/images/technology-3.jpg", 
      date: "April 21, 2020",
      comments: 0
    }
  ],
  faq: [
    {
      id: 1,
      question: "What plumbing services do you offer?",
      answer: null,
      isExpanded: false
    },
    {
      id: 2,
      question: "Do you offer emergency plumbing services?", 
      answer: null,
      isExpanded: false
    },
    {
      id: 3,
      question: "How can I prevent clogged drains?",
      answer: null,
      isExpanded: false
    },
    {
      id: 4,
      question: "Why is my water pressure low?",
      answer: null,
      isExpanded: false
    }
  ],
  contactInfo: {
    title: "Have Questions? Get in touch!",
    description: "Adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim.",
    ctaText: "Subcribe",
    details: {
      address: {
        country: "Germany —",
        street: "785 15h Street, Office 478", 
        city: "Berlin, De 81566"
      },
      phone: "+1 840 841 25 69",
      email: "info@email.com",
      hours: {
        weekdays: "Mon-Fri: 9 AM – 6 PM",
        saturday: "Saturday: 9 AM – 4 PM",
        sunday: "Sunday: Closed"
      }
    },
    map: "/images/contact-map.svg"
  },
  footer: {
    logo: "/images/footer-logo.png",
    tagline: "We develop & create healthier future",
    newsletter: {
      title: "Join a Newsletter",
      subtitle: "Your Email", 
      placeholder: "Enter Your Email",
      buttonText: "Send"
    },
    sections: {
      socials: {
        title: "Socials",
        links: ["Facebook", "Twitter", "Instagram"]
      },
      menu: {
        title: "Menu",
        links: ["Home", "Services", "About Us", "Contacts"]
      },
      contact: {
        title: "Say Hello",
        email: "info@email.com"
      }
    },
    copyright: {
      brand: "visibeen",
      text: "© 2025. All Rights Reserved."
    }
  },
  location: {
    title: "Find Us",
    subtitle: "Visit our location or reach out to us for more information",
    address: "47 Bakery Street, London, UK"
  }
};